import React from "react";
import {
  Sandwich, Flame, Fish, Cake, CupSoda, Popcorn, UtensilsCrossed, Salad,
  Sparkles, Globe, Package, Truck, ShoppingCart, HeartHandshake, Wine,
  Croissant, Leaf, EggFried, Users, Moon, Home, Coffee, Carrot, Drumstick,
  Beef, Utensils, ChefHat, Store,
} from "lucide-react";

/**
 * CategoryIcon — Hidden Gem's unified category symbol system (Phase 2).
 * Renders a professional vector icon for each food/vendor category. No emojis.
 *
 * Props:
 *   slug      — category value (e.g. "street_food", "bbq")
 *   size      — pixel size (default 20)
 *   className — extra classes for coloring
 *   strokeWidth — stroke weight (default 2)
 */
export const CATEGORY_ICON_MAP = {
  street_food:    Sandwich,
  bbq:            Flame,
  seafood:        Fish,
  mexican:        Flame,           // spicy pepper stand-in
  soul_food:      Drumstick,
  desserts:       Cake,
  drinks:         CupSoda,
  snacks:         Popcorn,
  plates:         UtensilsCrossed,
  meal_prep:      Salad,
  pop_ups:        Sparkles,
  cultural:       Globe,
  wholesale:      Package,
  food_trucks:    Truck,
  food_carts:     ShoppingCart,
  fundraisers:    HeartHandshake,
  catering:       Wine,
  home_bakery:    Croissant,
  vegan:          Leaf,
  breakfast:      EggFried,
  family_owned:   Users,
  late_night:     Moon,
  homemade:       Home,
  wings:          Drumstick,
  coffee:         Coffee,
  farmers_market: Carrot,
  hibachi:        Beef,
  // Fallback catch-alls
  food:           Utensils,
  chef:           ChefHat,
  store:          Store,
};

export default function CategoryIcon({ slug, size = 20, className = "", strokeWidth = 2, ...rest }) {
  const Icon = CATEGORY_ICON_MAP[slug] || Utensils;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      data-testid={`category-icon-${slug || "unknown"}`}
      {...rest}
    />
  );
}
